import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {CustomerBankAccount} from './customer-bank-account.model';
import urlJoin from 'url-join';
import { ROUTE_TOKEN_GATEWAY_URL } from '../shared/interceptors/gateway-url.interceptor';

@Injectable()
export class CustomerBankAccountService {

  constructor(private http: HttpClient) { }

  getBankAccounts(tenantId: string): Observable<CustomerBankAccount[]> {
    return this.http.get<CustomerBankAccount[]>(
      urlJoin(this._getUri('info', tenantId, '')
      ), {
        headers: {}
      });
  }

  private _getUri(path: string, tenantId: string, params: string) {
    let uri = urlJoin(ROUTE_TOKEN_GATEWAY_URL, `payment/v1/tenants/${encodeURI(tenantId)}/banks/accounts`);
    uri = urlJoin(uri, path);
    if (params) {
      uri += '?' + params;
    }
    return uri;
  }

}
